import React, { useState, useEffect } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from "@/components/ui/dialog";
import { Select, SelectTrigger, SelectValue, SelectContent, SelectItem } from "@/components/ui/select";
import { UserCog } from "lucide-react";

export const AssetReassignDialog = ({ open, onClose, onConfirm, employees, target, saving }) => {
  const [empId, setEmpId] = useState("none");

  useEffect(() => {
    if (open) setEmpId(target?.currentEmployeeId || "none");
  }, [open, target]);

  const submit = () => {
    const emp = employees.find((e) => e.id === empId);
    onConfirm({ id: empId === "none" ? "" : empId, name: emp ? emp.name : "" });
  };

  return (
    <Dialog open={open} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-w-[460px]" data-testid="asset-reassign-dialog">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2"><UserCog size={18} className="text-[#0d6cb8]" /> Riassegna bene</DialogTitle>
          <DialogDescription className="text-[13px] text-gray-600">{target?.label}</DialogDescription>
        </DialogHeader>
        <div>
          <label className="block text-[12px] font-semibold text-gray-600 mb-1">Nuovo assegnatario</label>
          <Select value={empId} onValueChange={setEmpId}>
            <SelectTrigger data-testid="reassign-employee-select"><SelectValue placeholder="Nessun assegnatario" /></SelectTrigger>
            <SelectContent className="max-h-[280px]">
              <SelectItem value="none">Nessun assegnatario</SelectItem>
              {employees.map((e) => <SelectItem key={e.id} value={e.id}>{e.name} ({e.matricola})</SelectItem>)}
            </SelectContent>
          </Select>
          <p className="text-[11px] text-gray-400 mt-2">Lo storico assegnazioni verrà aggiornato automaticamente. Se il bene era riconsegnato, tornerà attivo.</p>
        </div>
        <DialogFooter>
          <button onClick={onClose} data-testid="reassign-cancel" className="px-4 py-2 text-[13px] font-semibold text-gray-600 hover:bg-gray-100 rounded-sm transition-colors">Annulla</button>
          <button onClick={submit} disabled={saving} data-testid="reassign-confirm" className="px-4 py-2 text-[13px] font-bold text-white bg-[#16345c] hover:bg-[#0d1b2f] rounded-sm transition-colors disabled:opacity-60">{saving ? "Salvataggio..." : "Riassegna"}</button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
